class AboDisplay {
  constructor() {
    this.inited = false;
    this.pagedatas = Object.assign({
      "pagetype" : null,
      "contentname": null,
      "contentobjectid": null,
      "contentclassid": null,
      "contentclassidentifier": null,
      "tagids": [],
      "pathstring": null,
      "url": null,
    }, ( document.body.dataset.pagedatas? JSON.parse( document.body.dataset.pagedatas ) : {} ) );
    this.possibleblocs = {};
  }

  async fillAboContainers( userinfos, userroles ){
    let AboDisplay = this;
    let pagedatas = AboDisplay.pagedatas;
    let possibleblocs = AboDisplay.possibleblocs;

    const abocontainers = document.getElementsByClassName("abo");
    if( abocontainers != null ){
      for (let i = 0; i < abocontainers.length; i++) {
        let abocontainer = abocontainers[i];
        if( abocontainer.dataset.typeabo ){
          let typeabo = abocontainer.dataset.typeabo;

          if( [ 'toaster','abovecontent','popin' ].includes(typeabo) && [ 'frontpage_ops','publi' ].includes(pagedatas.contentclassidentifier ) ){
            return;
          }



          if( !Cookies.get( "closed-abo-"+typeabo ) ){
            let blocktitle = abocontainer.dataset.name? abocontainer.dataset.name : 'En vente ce mois-ci';
            // get first abo bloc from possible blocs
            if( typeof possibleblocs[typeabo] !== 'undefined')
            {
              if( possibleblocs[typeabo].length )
              {
                for ( const [i, possiblebloc] of Object.entries(possibleblocs[typeabo] ) )
                {

                  // if possible bloc has filter by tree
                  if(typeof possiblebloc.exclude_premium !== 'undefined' && possiblebloc.exclude_premium == 1 && pagedatas.premium  == 1 )
                  {
                    continue;
                  }

                  if(typeof possiblebloc.include_premium !== 'undefined' && possiblebloc.include_premium == 1 && pagedatas.premium  == 0 )
                  {
                    continue;
                  }

                  if( typeof possiblebloc.abo_mag !== 'undefined' && possiblebloc.abo_mag != null ){
                    let escapethisbloc = false;
                    for ( const [i, excludedabo] of Object.entries(possiblebloc.abo_mag) ){
                      if( typeof userroles[excludedabo] !== 'undefined' && userroles[excludedabo] == true ){
                        escapethisbloc = true;
                      }
                    }

                    if( escapethisbloc ){
                      continue;
                    }
                  }

                  if( typeabo.indexOf('sidebar') != -1 && window.innerWidth > 992 )
                  {
                    continue;
                  }

                  if( typeabo == 'formnewsletter' && typeof userroles.abonne_news !== 'undefined' && userroles.abonne_news == true )
                  {
                    continue;
                  }

                  if( typeof possiblebloc.contentobject_ids !== 'undefined' && possiblebloc.contentobject_ids != null && possiblebloc.contentobject_ids )
                  {
                    if( typeabo  == 'toaster' )
                    {
                      AboDisplay.loadToaster(typeabo);
                    }

                    let pathstring = pagedatas.pathstring.replace(/^\//,'').replace(/\/$/,'');
                    if( typeabo == 'abovecontent' && pagedatas.contentobjectid !=  1 )
                    {
                      pathstring = pagedatas.pathstring.replace(/\/1\//,'').replace(/\/$/,'');
                    }

                    let intersect = pathstring.split('/').filter( value => possiblebloc.contentobject_ids.includes(value));
                    if( !intersect.length && !possiblebloc.contentobject_ids.includes( pagedatas.contentobjectid ) )
                    {
                      continue;
                    }
                  }

                  // if possible bloc has filter by contentclass
                  if( typeof possiblebloc.contentclass_ids !== 'undefined' && possiblebloc.contentclass_ids != null && possiblebloc.contentclass_ids.length )
                  {
                    if( !possiblebloc.contentclass_ids.includes( pagedatas.contentclassid.toString() ) )
                    {
                      continue;
                    }
                  }

                  if( typeabo == 'popin' )
                  {
                    AboDisplay.loadPopin( abocontainer, possiblebloc, typeabo );
                  }
                  else
                  {
                    abocontainer.innerHTML = possiblebloc.html.replace( '%blocktitle%', blocktitle );
                  }

                  if( possiblebloc.qualifio)
                  {
                    let script = document.createElement("script");
                    script.type = "text/javascript";
                    script.appendChild(document.createTextNode(possiblebloc.qualifioscript));
                    abocontainer.appendChild(script);
                  }

                  if( abocontainer.querySelector('.formnewsletter') )
                  {
                    let formnewsletter = abocontainer.querySelector('.formnewsletter');
                    if( formnewsletter.querySelector('.errorformnewsletter') ){
                      formnewsletter.querySelector('.errorformnewsletter').innerHTML = '';
                    }
                    if( formnewsletter.querySelector('.errorformnewsletterpostalcode') ){
                      formnewsletter.querySelector('.errorformnewsletterpostalcode').innerHTML = '';
                    }

                    if( formnewsletter.querySelector('.emailformnewsletter') ){
                      formnewsletter.querySelector('.emailformnewsletter').addEventListener( 'focus', (e)=>{
                        formnewsletter.querySelector('.legal').style.display = 'block';
                        formnewsletter.querySelector('.text-cnil').style.display = 'block';
                      });

                      formnewsletter.querySelector('.emailformnewsletter').addEventListener( 'focusout', (e)=>{
                        formnewsletter.querySelector('.legal').style.display = 'none';
                        formnewsletter.querySelector('.text-cnil').style.display = 'none';
                      });
                    }

                    if( formnewsletter.querySelector('.btnformnewsletter') ){
                      formnewsletter.querySelector('.btnformnewsletter').addEventListener( 'click', (e)=>{
                        let email = formnewsletter.querySelector('.emailformnewsletter')? formnewsletter.querySelector('.emailformnewsletter').value : '';
                        let haspostalcode = formnewsletter.querySelector('.codepostalformnewletter') ? true : false;
                        let postalcode = formnewsletter.querySelector('.codepostalformnewletter')? formnewsletter.querySelector('.codepostalformnewletter').value : null;

                        if( /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email) && ( !haspostalcode || (haspostalcode && postalcode!= null) ) )
                        {
                          fetch( '/compte/submitformnews', {
                            cache: "no-store",
                            method: "POST",
                            headers: {
                              "Content-Type": "application/json",
                            },
                            body: JSON.stringify({
                              email:email,
                              id:possiblebloc.id,
                              postalcode:postalcode,
                            }),
                          }).then( (response) => {
                            return response.json();
                          }).then( (result) => {
                            if( result.success ){
                              abocontainer.querySelector('.formnewsletter').innerHTML = '<div class="titleformnewsletter">Merci pour votre inscription !</div><p>Vous recevrez très prochainement la newsletter</p>';
                            } else {
                              abocontainer.querySelector('.formnewsletter').innerHTML = '<div class="titleformnewsletter">Erreur lors de votre inscription !</div><p>Veuillez réessayer plus tard.</p>';
                            }
                            resolve();
                          }).catch( () => {
                            abocontainer.querySelector('.formnewsletter').innerHTML = '<div class="titleformnewsletter">Erreur lors de votre inscription !</div><p>Veuillez réessayer plus tard.</p>';
                          });
                        }
                        else if ( haspostalcode && postalcode != null )
                        {
                          formnewsletter.querySelector('.errorformnewsletterpostalcode').innerHTML = "Le code postal est invalide";
                        }
                        else if (!(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)))
                        {
                          formnewsletter.querySelector('.errorformnewsletter').innerHTML = "L'email est invalide";
                        }
                      });
                    }
                  }

                  [... abocontainer.querySelectorAll('.close')].map( closelink => {
                    closelink.addEventListener('click', (e) => {
                      abocontainer.remove();
                      let closedabo = "closed-abo-"+typeabo;
                      if( typeabo == 'popin' )
                      {
                        closedabo = "closed-abo-"+typeabo+"-"+possiblebloc.id;
                      }
                      Cookies.set( closedabo, 1, {expires: 2} );
                    });
                  });

                  break;
                }
              }
            }
          }
        }
      }
    }
  }

  async loadPopin( abocontainer, bloc, typeabo ){
    let count_page = 0;
    let url = new URL(window.location.href);
    let utm_medium = url.searchParams.get("utm_medium");
    if( url.pathname == '/compte/inscription' || url.pathname == '/compte/loginsuccess' || url.pathname == "/compte/mes-informations" || url.pathname == "/compte/mes-newsletters" || url.pathname == "/compte/modifier-mon-mot-de-passe" || url.pathname == "/compte/mes-abonnements" || url.pathname == '/compte/espace-abonnes' || url.pathname == '/mes-avantages' )
    {
      return false;
    }

    if( utm_medium == 'email' )
    {
      sessionStorage.setItem('newsletter_nt',1);
    }

    if( !sessionStorage.getItem('newsletter_nt') )
    {
      if( !sessionStorage.getItem('count_page_'+bloc.id) )
      {
        count_page = 1
      }
      else{
        count_page =  parseInt(sessionStorage.getItem('count_page_'+bloc.id)) +1;
      }
    }
    sessionStorage.setItem('count_page_'+bloc.id,count_page);

    if(!sessionStorage.getItem("closed-abo-"+typeabo+"-"+bloc.id) && sessionStorage.getItem('count_page_'+bloc.id) == 3)
    {
      abocontainer.innerHTML = bloc.html;
    }
  }

  async loadToaster( typeabo ){
    if( window.innerWidth > 992  && !Cookies.get("closed-abo-"+typeabo) )
    {
       setTimeout( function()
       {
         let elt = document.getElementsByClassName("abo-toaster")[0];
         elt.style.display = "block";
         elt.style.opacity = 0;
         let opacity = 0;
         setInterval(() => {
           elt.style.opacity = opacity;
           if(opacity < 1){
             opacity += 0.01;
           }
         }, 10);
       }, 2000);
    }
  }

  async init( userinfos, userroles ){
    console.log( 'Abodisplay : init', userinfos, userroles );
    let AboDisplay = this;
    if( !AboDisplay.inited ){
      AboDisplay.inited = true;
      return new Promise((resolve, reject) => {
        return fetch( '/abonnement/list-bloc-abo.json', {
          cache: "no-store",
          method: "GET",
          credentials:"omit"
        }).then( (response) => {
          return response.json();
        }).then( (abodatas) => {
          AboDisplay.possibleblocs = abodatas;
          AboDisplay.fillAboContainers( userinfos, userroles );
          resolve();
        }).catch( () => {
          reject( 'Erreur lors de l\'envoi de demande des blocs abo' );
        });
      });
    }
  }
}

currentuser.onUserLoad( (e) => {
  let abodisplay = new AboDisplay();
  abodisplay.init( e.detail.userinfos, e.detail.roles );
});